import React from "react";
import { Truck, Phone, Mail, MapPin, AlertTriangle } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function MaintenancePage() {
  return (
    <div data-testid="website-down-page" className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#0B0F17] px-6 text-slate-100">
      {/* ambient grid + glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.6) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="pointer-events-none absolute -top-40 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-orange-600/20 blur-[120px]" />

      <div className="relative z-10 w-full max-w-lg text-center">
        <div className="mx-auto mb-8 flex items-center justify-center gap-2">
          <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-orange-600">
            <Truck className="h-6 w-6 text-white" />
          </div>
          <span className="text-xl font-black tracking-tight">GO DELIVER</span>
        </div>

        <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-orange-600/40 bg-orange-600/10 px-4 py-1.5">
          <AlertTriangle className="h-4 w-4 text-orange-400" />
          <span data-testid="website-down-badge" className="font-mono text-xs uppercase tracking-[0.2em] text-orange-300">
            Service Unavailable
          </span>
        </div>

        <h1 data-testid="website-down-heading" className="text-4xl font-black tracking-tight sm:text-5xl">
          Website<br /><span className="text-orange-500">Down.</span>
        </h1>
        <p className="mx-auto mt-5 max-w-md text-base text-slate-400">
          The Go Deliver website is currently down. Your shipments, tracking numbers and
          account are safe. Please contact us below if you need help.
        </p>

        {/* animated progress shimmer */}
        <div className="mx-auto mt-8 h-1.5 w-56 overflow-hidden rounded-full bg-white/10">
          <div className="maint-bar h-full w-1/3 rounded-full bg-orange-500" />
        </div>

        <div className="mt-10 flex flex-col items-center gap-2 text-sm text-slate-400">
          <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-orange-400" /> {COMPANY.country}</p>
          <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2 hover:text-orange-300">
            <Phone className="h-4 w-4 text-orange-400" /> {COMPANY.phone}
          </a>
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 break-all hover:text-orange-300">
            <Mail className="h-4 w-4 text-orange-400" /> {COMPANY.email}
          </a>
        </div>

        <p className="mt-10 text-xs text-slate-600">
          © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
        </p>
      </div>
    </div>
  );
}
